export enum DateFormat {
  DayMonthYear = 'D/M/Y',
  DayMonthYearDash = 'D-M-Y',
  MonthDayYear = 'M/D/Y',
  MonthDayYearDash = 'M-D-Y',
  YearMonthDay = 'Y/M/D',
  YearMonthDayDash = 'Y-M-D',
}
